import { RenderManualFieldExtensionConfigScreenCtx } from "datocms-plugin-sdk";
import { Canvas, Form, TextField } from "datocms-react-ui";
import { useState, useCallback } from "react"; 

type PropTypes = {
  ctx: RenderManualFieldExtensionConfigScreenCtx;
};

export type ValidationParameter = {
  dependencies: string;
};

export function CustomFieldExtensionConfigScreen({ ctx }: PropTypes) {
  const [formValues, setFormValues] = useState<Partial<ValidationParameter>>(
    ctx.parameters,
  );
  const update = useCallback(
    (field: string, value: unknown) => {
      const newParameters = { ...formValues, [field]: value };
      setFormValues(newParameters);
      ctx.setParameters(newParameters);
    },
    [formValues, setFormValues, ctx]
  );

  return (
    <Canvas ctx={ctx}>
    <Form>
      <TextField
      id="dependencies" 
      name="dependencies" 
      label="Dependencias"
      value={formValues.dependencies || ''} 
      onChange={update.bind(null, 'dependencies')}  />
    </Form>
    </Canvas>
  );
}
